export default __webpack_public_path__ + "static/media/marker11.7822fec9.svg";